module.exports = __webpack_public_path__ + "img/logo-blogs.79d08c33.svg";